// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__yjkxt","textBox":"styles_textBox__KgJKb","tag":"styles_tag__OMXsM","invalid":"styles_invalid__EYCJO"};